"use client";
import {
  ripple_default
} from "./chunk-SC6YC33A.mjs";
import {
  useRipple
} from "./chunk-6NL67ZRH.mjs";
export {
  ripple_default as Ripple,
  useRipple
};
